import { useQuery } from '@tanstack/react-query';
import { usersService } from '../../../services';

export function useUser(userId: string | undefined) {
  return useQuery({
    queryKey: ['user', userId],
    enabled: Boolean(userId),
    queryFn: async () => {
      if (!userId) throw new Error('userId is required');
      const response = await usersService.getUserById(userId);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar usuário');
      }
      return response.data;
    },
    staleTime: 1000 * 60,
  });
}
